import React from "react";
import PropTypes from "prop-types";

const EmptyGraphMessage = ({message}) => {
  return (
    <div
      style={{
        minHeight: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
        fontWeight: 700,
        textAlign: "center",
      }}
      className="roboto-bold"
    >
      {message}
    </div>
  );
};

EmptyGraphMessage.propTypes = {
  /** Message to be displayed */
  message: PropTypes.string.isRequired,
};

export default EmptyGraphMessage;
